import type { ReactNode } from 'react';

/** Stat card used across adoption / readiness / exec summary. */
export function Metric({
  label,
  value,
  sub,
  tone = 'default',
}: {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  tone?: 'default' | 'accent' | 'red' | 'green';
}) {
  const toneClass = tone === 'default' ? '' : ` metric__value--${tone}`;
  return (
    <div className="metric">
      <p className="metric__label">{label}</p>
      <div className={`metric__value${toneClass}`}>{value}</div>
      {sub != null && <div className="metric__sub">{sub}</div>}
    </div>
  );
}

export function MetricGrid({ children }: { children: ReactNode }) {
  return <div className="metrics">{children}</div>;
}
